import { createSelector } from "@reduxjs/toolkit";
const selectErrorCode = (state) => state.errorBoundary.errorCode;
const selectErrorNumber = (state) => state.errorBoundary.errorNumber;
const selectShowErrorModal = (state) => state.errorBoundary.showErrorModal;

export const manageErrorBoundarySelector = createSelector(
  [selectErrorCode, selectErrorNumber, selectShowErrorModal],
  (errorCode, errorNumber, showErrorModal) => ({
    errorCode,
    errorNumber,
    showErrorModal,
  })
);
